import React from "react"
import { Typography } from "@material-ui/core"

export const SectionText = (props) => (
  <Typography paragraph>{props.children}</Typography>
)
